import React from 'react';
import classNames from 'classnames';


import {IconProps} from "../icons";

import './HintRow.css';


export interface HintRowProps {
    text: string;
    number: string | number;
    className?: string;
    Icon?: React.ComponentType<IconProps>;

}

export const HintRow = ({ 
    text, 
    number, 
    className,
    Icon,
}: HintRowProps) => {
    return (
        <div className={classNames('HintRow', className)}>
            <div className="HintRow__text body-medium">
                {text}
            </div>
            <div className="HintRow__end">
                <div className="HintRow__number body-large-bold">
                    {number}
                </div>
                {Icon && (
                    <Icon
                        size={20}
                        className="HintRow__icon"
                    />
                )}
            </div>
        </div>
    );
};